export const getVisualSearchConfig = /* GraphQL */ `
    query getVisualSearchConfig {
        config {
            base {
                pwa {
                    visual_search_enabled
                }
            }
        }
    }
`
